import script from "./TeamElement.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamElement.vue?vue&type=script&setup=true&lang=js"

import "./TeamElement.vue?vue&type=style&index=0&id=a1ec06be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1ec06be"]])

export default __exports__